import { SelectedKpiSliceType } from "../../../types";

export const initSelectedKpi :SelectedKpiSliceType = {
    selection:[ {
        vertical: "",
        selected:"",
    }
]

}